import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

import PostAdModal from "./PostAdModal";
import API from "../api/axios";

const menuItems = [
  { label: "Home", path: "/" },
  { label: "Discover", path: "/discover" },
  { label: "Add Project", path: "/submit-project" },
  { label: "LaunchBoard", path: "/launchBoard" },
  { label: "My Projects", path: "/my-projects" },
];

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const [showAdModal, setShowAdModal] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [getlogo, setLogo] = useState();

  useEffect(() => {
  API.get("/settings/")
    .then((res) => {
      const getlogofront = res.data.find(
        (item) => item.key === "logo"
      );
      if (getlogofront) {
        setLogo(getlogofront.logo_url);
      }
    })
    .catch((err) => {
      console.error("Error fetching settings:", err);
    });
}, []);
 
  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("loginUser");
    setIsLoggedIn(false);
    navigate("/login");
  };

  return (
    <header>
      <div className="container">
        <div className="header-inner">
          <div className="header-logo-main">
            <Link
              to="/"
              className="logo-main"
              title="Leaderboard Microservice"
            >
              {getlogo ? (
                <img
                  src={getlogo}
                  alt="Logo"
                  className="h-10"
                />
              ) : (
                "LM"
              )}
            </Link>
          </div>

          <div className="header-navbar">
            <ul className="menu-main">
              {menuItems.map(({ label, path }) => (
                <li key={path} className="menu-item">
                  <Link
                    to={path}
                    className={
                      location.pathname === path
                        ? "active menu-link"
                        : "menu-link"
                    }
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="header-btn">
            {isLoggedIn ? (
              <button
                className="btn btn-logout"
                onClick={handleLogout}
              >
                Logout
              </button>
            ) : (
              <Link to="/login" className="btn btn-white">
                Login
              </Link>
            )}

            <button
              className="btn"
              style={{ backgroundColor: "#5A4CFF", color: "#ffffff" }}
              onClick={() => setShowAdModal(true)}
            >
              Post your Ad
            </button>

            <a
              href="#"
              className="menu-icon"
              id="menu-toggle"
              tabIndex={1}
              onClick={() => setShowMenu(true)}
            >
              <span></span>
            </a>
          </div>
        </div>
      </div>

      {/* Menu Modal */}
      <Modal
        show={showMenu}
        onHide={() => setShowMenu(false)}
        dialogClassName="menuModal"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="d-none">Menu</Modal.Title>
          {/* <Link to="/" className="navbar-brand" title="Leaderboard Microservice">
            LM
            <span className="small">Leaderboard Microservice</span>
          </Link> */}

          <Link
              to="/"
              className="navbar-brand" 
              title="Leaderboard Microservice"
            >
              {getlogo ? (
                <img
                  src={getlogo}
                  alt="Logo"
                  className="h-10"
                  style={{ width: "100px" }}
                />
              ) : (
                "LM"
              )}
            </Link>
        </Modal.Header>

        <Modal.Body className="menuModalBody">
          <ul className="menu-main list-unstyled mb-4">
            {menuItems.map(({ label, path }) => (
              <li key={path} className="mb-2">
                <Link
                  to={path}
                  onClick={() => setShowMenu(false)}
                  className={`menu-link ${location.pathname === path ? "active" : ""}`}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>

          <div className="header-btn">
              {isLoggedIn ? (
                <Button
                  variant="danger"
                  className="w-50 rounded-pill"
                  onClick={handleLogout}
                >
                  Logout
                </Button>
              ) : (
                <Link
                  to="/login"
                  className="btn btn-outline-secondary w-50 rounded-pill"
                  onClick={() => setShowMenu(false)}
                >
                  Login
                </Link>
              )}

              <Button
                variant="primary"
                className="w-50 rounded-pill shadow-sm"
                onClick={() => setShowAdModal(true)}
              >
                Post your Ad
              </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Post Ad Modal */}
      <PostAdModal show={showAdModal} onHide={() => setShowAdModal(false)} />
    </header>
  );
}
